import React, { useState } from "react";
import LoginPage from "./pages/LoginPage";
import BoronRecordPage from "./pages/BoronRecordPage";

const AUTH_STATUS_KEY = "bamboo_is_authenticated";
const AUTH_USER_KEY = "bamboo_current_user";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return localStorage.getItem(AUTH_STATUS_KEY) === "true";
  });
  const [currentUser, setCurrentUser] = useState(() => {
    return localStorage.getItem(AUTH_USER_KEY) || "admin";
  });

  const handleLogin = (username) => {
    localStorage.setItem(AUTH_STATUS_KEY, "true");
    localStorage.setItem(AUTH_USER_KEY, username);
    setCurrentUser(username);
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    localStorage.removeItem(AUTH_STATUS_KEY);
    localStorage.removeItem(AUTH_USER_KEY);
    setIsAuthenticated(false);
  };

  return (
    <div className="App">
      {!isAuthenticated ? (
        <LoginPage onLogin={handleLogin} />
      ) : (
        <BoronRecordPage onLogout={handleLogout} currentUser={currentUser} />
      )}
    </div>
  );
}

export default App;
